var entryContent = document.querySelector('.entry-content');
if (entryContent && entryContent.innerHTML.trim() === '') {
	entryContent.style.display = 'none';
}

function initSteps() {
	const navItems = document.querySelectorAll('.step-nav-item');
	const steps = document.querySelectorAll('.Step.Overview .block-grid li');

	if (navItems.length === 0 || steps.length === 0) {
		return;
	}

	// --- HOVER LOGIC ---
	navItems.forEach(item => {
		item.addEventListener('mouseenter', function () {
			const step = this.getAttribute('data-step');

			steps.forEach(el => el.classList.remove('active'));
			navItems.forEach(el => el.classList.remove('active'));

			this.classList.add('active');

			const target = document.querySelector('.block-grid li[data-step="' + step + '"]');
			if (target) {
				target.classList.add('active');
			}
		});
	});

	// --- HEIGHT EQUALIZER ---
	function equalizeHeights() {
		let maxHeight = 0;

		// Reset heights first
		steps.forEach(el => {
			el.style.height = 'auto';
		});

		// Measure all
		steps.forEach(el => {
			maxHeight = Math.max(maxHeight, el.offsetHeight);
		});

		// Apply max height
		steps.forEach(el => {
			el.style.height = maxHeight + 'px';
		});
	}

	// Run after everything is loaded (important for images)
	window.addEventListener('load', equalizeHeights);
	window.addEventListener('resize', equalizeHeights);
}

// Init
document.addEventListener('DOMContentLoaded', initSteps);